<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      v-if="isAuthenticated"
      scrollable
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-fab-transition>
          <v-btn
            v-bind="attrs"
            v-on="on"
            fab
            fixed
            right
            bottom
            color="primary-light"
            class="fidelity-card-fab mb-1"
          >
            <v-img
              src="/img_layout/fidelity_card/PRIMACARD.png"
              contain
              height="55"
              width="55"
            />
          </v-btn>
        </v-fab-transition>
      </template>

      <div class="fidelity-card-fab-container" v-if="dialog">
        <v-btn @click.stop="dialog = false" icon class="close">
          <v-icon>$close</v-icon>
        </v-btn>
        <v-card class="green lighten-2 dialog-fullscreen-content flex-column">
          <div class="dialog-barcode-center">
            <barcode
              :value="fidelityCard"
              :options="{ format: 'CODE128', width: 380, height: 150 }"
              class="align-self-center"
            />
          </div>
          <div class="d-flex align-items-center justify-center">
            <img
              class="card-img align-self-end"
              src="/img_layout/prima_cards/prima-cards.svg"
              alt="Prima Card"
              title="Logo Prima Card"
            />
          </div>
        </v-card>
      </div>
    </v-dialog>
  </div>
</template>
<style lang="scss">
.is-cordova {
  .fidelity-card-fab {
    bottom: calc(
      #{$bottom-navigation-bar-height} + env(safe-area-inset-top) + 70px
    );
    padding-left: 40px;
    padding-right: 40px;
    border-radius: 20px !important;
    border: 2px solid var(--v-primary-darken1) !important;
    right: 2%;
    background-color: var(--v-primary-base) !important;
    color: $black !important;
    &::before {
      background-color: unset !important;
    }
    .v-btn__content {
      flex-direction: column;
      display: flex;
      white-space: nowrap;
    }
    .fidelity-card-fab-label {
      font-size: 9px;
      margin-top: 2px !important;
    }
  }
  .fidelity-card-fab-container {
    position: relative;
  }
  .close {
    position: absolute;
    top: 0px;
    right: 0px;
    height: 55px;
    width: 55px;
    color: $black;
    border: none !important;
  }
}
.is-cordova.keyboard-open {
  .fidelity-card-fab {
    bottom: 4px !important;
  }
}

.is-cordova.keyboard-open.platform-ios {
  .fidelity-card-fab {
    bottom: 20px !important;
  }
}
.dialog-fullscreen-content {
  position: relative;
  width: 100dvw;
  height: 100dvh;
  display: flex;
  align-items: center;
  // justify-content: center;
  img {
    max-width: 100%;
  }
}
.dialog-barcode-center {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30%;
  height: 30%;
}
.close {
  position: absolute;
  top: 16px;
  right: 16px;
  color: $black;
  border: none !important;
  z-index: 2;
}
</style>
<script>
import { mapGetters, mapState } from "vuex";
import get from "lodash/get";

export default {
  data() {
    return {
      dialog: false,
      oldBrightness: null
    };
  },
  components: {},
  computed: {
    ...mapState({
      cart: ({ cart }) => cart.cart
    }),
    ...mapGetters({
      isAuthenticated: "cart/isAuthenticated"
    }),
    fidelityCard() {
      console.log("FIDELITY CARD:", get(this.cart, "user.fidelityCard"));
      return get(this.cart, "user.fidelityCard");
    }
  },
  mounted() {
    let _this = this;
    global.EventBus.$on("closeDialog", () => {
      this.dialog = false;
      // eslint-disable-next-line no-undef
      cordova.plugins.brightness.setBrightness(_this.oldBrightness);
    });
  },
  methods: {},
  watch: {
    dialog(val) {
      let _this = this;
      if (val) {
        // eslint-disable-next-line no-undef
        cordova.plugins.brightness.getBrightness(
          function(data) {
            _this.oldBrightness = data;
            // eslint-disable-next-line no-undef
            cordova.plugins.brightness.setBrightness(1);
          },
          function(err) {
            console.log("error: " + err);
          }
        );
      } else {
        // eslint-disable-next-line no-undef
        if (_this.oldBrightness !== null) {
          // eslint-disable-next-line no-undef
          cordova.plugins.brightness.setBrightness(_this.oldBrightness);
        }
      }
    }
  }
};
</script>
